const ITEMS = [
  "Mobile Patrol",
  "Static Guarding",
  "Access Control",
  "Risk Management",
  "Construction Sites",
  "Industrial Security",
  "Consulting",
];

export const Marquee = () => {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="marquee"
      className="relative border-y border-white/10 bg-[color:var(--surface)] py-6 overflow-hidden"
    >
      <div className="animate-marquee flex items-center gap-10 w-max">
        {loop.map((item, i) => (
          <div key={i} className="flex items-center gap-10">
            <span className="font-display text-2xl md:text-4xl tracking-tight text-white/80">
              {item}
            </span>
            <span className="text-[color:var(--primary-text)] text-2xl md:text-4xl">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
};
